(function (module) {
  'use strict';
  module
    .controller('ssoOrganizationsController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService',
      'ssoOrganizations', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state',
      '$stateParams', 'toastFactory', 'authService',
      function ($scope, progressBar, clientSelectService, agencySelectService, ssoOrganizations, ngDialog,
        uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, toastFactory, authService) {
        const progress = progressBar.getProgressBar();
        let id = $stateParams.id;
        $scope.ssoOrganization = {};
        $scope.validate = {};

        if (!!id) {
          getSsoOrganizationById(id);
          $scope.isEdit = true;
        };

        function getSsoOrganizationById(id) {
          progress.start();
          ssoOrganizations.getSsoOrganizationById(id).then(function (ssoOrganization) {
            $scope.isEdit = true;
            const ssoOrg = ssoOrganization.data[0];
            $scope.ssoOrganization = {
              id: ssoOrg.Id,
              organizationCode: ssoOrg.OrganizationCode,
              globalId: ssoOrg.GlobalId,
              organizationId: ssoOrg.OrganizationId
            };            
          }, function (err) {
            if (err.status != 401) {              
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;                     
                  $scope.errTitle = 'Get SSO Organization Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };
        // Begin ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        // ui-grid options
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          visible: true,
          enableColumnResizing: true,
          columnDefs: [{
            name: 'OrganizationCode',
            displayName: 'Organization Code',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'GlobalId',
            displayName: 'Global Id',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },],
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            // Show organization details on grid row selection.
            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };
        $scope.edit = function () {
          $state.go('app.editSsoOrganization', {
            id: $scope.rowSelectingId,
          });
        };
        $scope.saveSsoOrganization = function () {
          if ($scope.ssoOrganization.organizationCode && $scope.ssoOrganization.globalId) {
            const organization = clientSelectService.getSelectedClient();
            progress.start();
            ssoOrganizations.addSsoOrganization($scope.ssoOrganization, organization.id).then(function () { 
              const dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Add SSO Organization Success';
                  $scope.successMsg = 'The SSO Organization has been added succesfully.';
                },],
              });
              dialogPost.closePromise.then(function (data) {
                $state.go('app.ssoOrganizations');
              });
            }, function (err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} ${err.data}</p>`;                     
                  $scope.errTitle = 'SSO Organization Error';
                },],
              });
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            if (!$scope.ssoOrganization.organizationCode) {
              $scope.validate.organizationCode = true;
            }
            if (!$scope.ssoOrganization.globalId) {
              $scope.validate.globalId = true;
            }
          }
        };
        $scope.updateSsoOrganization = function () {
          if ($scope.ssoOrganization.organizationCode && $scope.ssoOrganization.globalId) {
            progress.start();
            ssoOrganizations.updateSsoOrganization($scope.ssoOrganization.id, $scope.ssoOrganization).then(function (organization) {
              const dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Update SSO Organization Success';
                  $scope.successMsg = 'The SSO Organization has been updated succesfully.';
                },],
              });
              dialogPost.closePromise.then(function (data) {
                $state.go('app.ssoOrganizations');
              });
            }, function (err) {              
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} ${err.data}</p>`;                     
                  $scope.errTitle = 'Update SSO Organization Error';
                },],
              });
            })
              .finally(function () {
                progress.complete();
              });
          } else {
            if (!$scope.ssoOrganization.organizationCode) {
              $scope.validate.organizationCode = true;
            }
            if (!$scope.ssoOrganization.globalId) {
              $scope.validate.globalId = true;
            }
          }
        };

        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function setGridData() {

          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            progress.start();
            let organization = clientSelectService.getSelectedClient();
            let organizationId = ((!!organization.id) ? organization.id : 0);
            ssoOrganizations.getSsoOrganizationsByOrgId(organizationId).then(function (ssoOrganizations) {
              const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
              $scope.gridOptions.data = ssoOrganizations.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
              $scope.gridOptions.totalItems = ssoOrganizations.data.length;              
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} ${err.data}</p>`;                     
                    $scope.errTitle = 'SSO Organization Error';
                  },],
                });
              }
            })
              .finally(function () {
                progress.complete();
              });
          } 
        };
        
        $scope.view = function (rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.ssoOrganization = selectedRow;
            const view = ngDialog.open({
              template: 'templates/partials/viewSsoOrganization.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function (data) {
              $scope.viewData = {};
            });
          }
        };

        setGridData();
        // Watch clientSelectService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            setGridData();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/ssoOrganizationsController.js